import { addAsRootValue } from '../../common-constants';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';
import { AddItemField } from './add-item-field';

export class AddItemConfig extends DestinationTaskConfigBase {
	addToField = addAsRootValue;
	rootFieldNameForAddedObject = 'newItem';
	useExpressionForItemsToAdd = false;
	amountOfItemsToAddExpression = '';
	amountOfItemsToAdd = 1;
	fieldMappings: AddItemField[] = [];

	constructor(init?: Partial<AddItemConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
			this.fieldMappings = (init.fieldMappings ?? []).map(field => new AddItemField(field));
		}
		if (!this.fieldMappings) {
			this.fieldMappings = [];
		}
	}
}
